import React from 'react';

import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';

import CreateVerifiedEmailAddressDialog from './CreateVerifiedEmailAddressDialog';
import SectionBody from './SectionBody';

export default function ApprovedSendersList(): JsxNode {
  return (
    <BaseSettingCard
      title="Approved senders"
      helpUrl="https://www.usewaypoint.com/docs/approved-senders"
      actions={<CreateVerifiedEmailAddressDialog />}
    >
      <SectionBody />
    </BaseSettingCard>
  );
}
